import React, { useState, useEffect } from "react";
import ConfettiExplosion from "react-confetti-explosion";

const BalloonEffect = ({ trigger }) => {
    const [explode, setExplode] = useState(false);

    useEffect(() => {
        if (trigger) {
            setExplode(true);
            setTimeout(() => setExplode(false), 3000); // Reset after animation
        }
    }, [trigger]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
            {explode && (
                <ConfettiExplosion
                    force={0.8}
                    duration={3000}
                    particleCount={250}
                    width={1600}
                />
            )}
        </div>
    );
};

export default BalloonEffect;